import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PatientsComponent } from './patients/patients.component';
import { ProvidersComponent } from './providers/providers.component';
import { ContactComponent } from './contact/contact.component';
import { FindAProivderComponent } from './find-a-proivder/find-a-proivder.component';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent
    },
    {
        path: 'patients',
        component: PatientsComponent
    },
    {
        path: 'providers',
        component: ProvidersComponent
    },
    {
        path: 'find-a-provider',
        component: FindAProivderComponent
    },
    {
        path: 'contact',
        component: ContactComponent
    }
];
